import React from 'react';
import Header from '../components/Header';
import SuccessStoriesSection from '../components/SuccessStoriesSection';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';

const SuccessStoriesPage = () => {
  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-20 pb-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 mb-6">Success Stories</h1>
          <p className="text-xl text-slate-600 font-light max-w-3xl mx-auto">Real people, real transformations, real careers</p>
        </div>
      </section>

      {/* Statistics */}
      <section className="py-12 bg-[#F9FAFB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-3 gap-8 text-center">
            <div className="p-6">
              <div className="text-5xl font-bold text-indigo-600 mb-2">500+</div>
              <div className="text-slate-600">Career Transformations</div>
            </div>
            <div className="p-6">
              <div className="text-5xl font-bold text-indigo-600 mb-2">6</div>
              <div className="text-slate-600">Months Average</div>
            </div>
            <div className="p-6">
              <div className="text-5xl font-bold text-indigo-600 mb-2">250%</div>
              <div className="text-slate-600">Salary Increase</div>
            </div>
          </div>
        </div>
      </section>

      <SuccessStoriesSection />
      
      {/* CTA Section */}
      <section className="py-16 bg-indigo-700 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold mb-6">Ready to Write Your Success Story?</h2>
          <p className="text-xl text-indigo-100 font-light mb-8">Every success story started with a single decision to change.</p>
          <Button size="lg" className="bg-white text-indigo-700 hover:bg-gray-100 font-semibold px-10 py-6 text-lg rounded-md" onClick={() => window.location.href = '/contact'}>
            Schedule Your Free Consultation
          </Button>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default SuccessStoriesPage;
